@use "../../style/mixins" as *;
@use "../../style/variables" as *;

.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.25rem;
}
.input {
  padding: 10px;
  display: block;
  border: none;
  border-bottom: 1px solid $white;
  font-size: 1.125rem;
  color: $white;
  background-color: transparent;
  width: 100%;
  box-sizing: border-box;
  border-radius: 0;
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  font-weight: 300;

  @include touch {
    font-size: 1rem;
  }

  &:focus {
    outline: none;
  }

  &.dark {
    border-bottom: 1px solid $black;
    color: $black;
  }

  &.grey {
    color: $grey;
    border: 1px solid $grey;
    font-family: inherit;
    line-height: 1.5rem;

    &::placeholder {
      color: $grey-light;
    }

    &:placeholder-shown {
      border: 1px solid $grey-light;
    }

    &:hover,
    &:focus {
      color: $grey;
      border: 1px solid $grey;

      &::placeholder {
        color: $grey;
      }
    }
  }
}

form {
  .input {
    &.grey {
      margin-bottom: 1.5rem;
      color: $grey;
      border: none;
      border-bottom: 1px solid $grey;
      padding-bottom: 0.25rem;

      &::placeholder {
        color: $grey-light;
      }

      &:placeholder-shown {
        border: none;
        border-bottom: 1px solid $grey-light;
      }

      &:hover,
      &:focus {
        color: $grey;
        border: none;
        border-bottom: 1px solid $grey;
        padding-bottom: 0.25rem;

        &::placeholder {
          color: $grey;
        }
      }
    }
  }
}

.label {
  font-size: 0.8rem;
  font-weight: 800;
}

.error {
  margin-bottom: .75rem;
  color: $grey;
  border: none;
  border-bottom: 1px solid $blue-info;
  padding-bottom: 0.25rem;

  &::placeholder {
    color: $grey-light;
  }

  &:placeholder-shown {
    border: none;
    border-bottom: 1px solid $blue-info;
    padding-bottom: 0.25rem;
  }

  &:hover,
  &:focus {
    color: $grey;
    border: none;
    border-bottom: 1px solid $blue-info;
    padding-bottom: 0.25rem;

    &::placeholder {
      color: $grey;
    }
  }
}


.error-message {
  color: $blue-info;

  .icon {
    &.exclamation svg {
      width: 0.75rem;
      height: 0.75rem;
      vertical-align: center;
      margin-right: 0.25rem;
    }
  }

  .solid {
    fill: $blue-info;
    stroke: none
  }
}